import { Badge, Grid, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { useAppDispatch } from '../../store/store';
import { fetchPendingCPTCodeChanges, setShowAddItemModal } from '../../store/adminCPTCodesSlice.slice';
import CPTCodeGroups from './CPTCodeGroups/CPTCodeGroups';
import EditRoleCodesModal from './CPTCodeGroups/EditRoleCodesModal';
import CPTCodes from './CPTCode/CPTCodes';
import PendingCPTCodeChanges from './PendingCPTCodeChanges/PendingCPTCodeChanges';
import AdminCPTModifierList from '../AdminCPTModifiers/AdminCPTModifierList';

const AdminCPTCodes = () => {
    const dispatch = useAppDispatch();
    const { showAddItemModal, pendingCPTCodeChanges } = useSelector((state: RootState) => state.adminCPTCodesSlice);
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        dispatch(fetchPendingCPTCodeChanges());
        document.title = 'CPT Codes';
    }, [dispatch]);

    return (
        <Grid container spacing={2} p={2}>
            <EditRoleCodesModal open={showAddItemModal} onClose={() => dispatch(setShowAddItemModal(false))} />

            <Grid size={12}>
                <Tabs variant={'fullWidth'} value={tabValue} onChange={(event, newValue) => setTabValue(newValue)}>
                    <Tab label="CPT Code Groups" value={0} />
                    <Tab label="CPT Codes" value={1} />
                    <Tab label="CPT Code Modifiers" value={2} />
                    <Tab
                        label={
                            <Badge badgeContent={pendingCPTCodeChanges.length} color="error">
                                Pending Changes
                            </Badge>
                        }
                        value={3}
                    />
                </Tabs>
            </Grid>
            <Grid size={12}>
                {tabValue === 0 && <CPTCodeGroups />}
                {tabValue === 1 && <CPTCodes canEdit={true} />}
                {tabValue === 2 && <AdminCPTModifierList />}
                {tabValue === 3 && <PendingCPTCodeChanges />}
            </Grid>
        </Grid>
    );
};

export default AdminCPTCodes;
